/**
 * FeedStreakScreen — the full-screen modal iOS shows after the feed streak
 * claim (FeedHeaderProgress.tsx:128-152: a fullScreen Modal wrapping the
 * placement StreakScreen with hideHeader + buttonText "Back to learning!").
 *
 * iOS reuses the placement-test StreakScreen for the content (fire animation,
 * "Commit to learning!", the four streak-goal cards, multiplier copy), so we
 * reuse its web port (StreakCommitment) the same way. The footer button stays
 * disabled until a goal is picked, exactly like the iOS PlacementFooter.
 */
import { useState } from "react";
import StreakCommitment from "@/components/PlacementTest/StreakCommitment";
import ContinueButton from "@/components/Buttons/ContinueButton";
import { colors } from "@/ui";

interface FeedStreakScreenProps {
  onContinue: () => void;
}

export function FeedStreakScreen({ onContinue }: FeedStreakScreenProps) {
  const [selectedDays, setSelectedDays] = useState<number | null>(null);

  return (
    <div
      className="fixed inset-0 z-[70] flex justify-center"
      style={{ backgroundColor: colors.background }}
    >
      {/* Phone-width column centered; the screen background bleeds full-width. */}
      <div className="flex flex-col h-full w-full max-w-[440px] justify-between items-center py-9 px-5">
        <StreakCommitment
          selectedDays={selectedDays}
          onStreakGoalChange={setSelectedDays}
        />
        <div className="flex justify-center items-center pb-6 bottom-padding-web w-full">
          <ContinueButton
            onClick={onContinue}
            text="Back to learning!"
            disabled={selectedDays === null}
          />
        </div>
      </div>
    </div>
  );
}
